import React from 'react'
import QrSvg from '../../../../assets/images/icon-qr.svg'
import './ScanButton.scss'

const ScanButton = ({ active, onPress }) => {
  return (
    <div className={`scan-button-container ${active ? 'active' : null}`} onClick={() => active ? onPress() : {}}>
      <img src={QrSvg} alt='Escanear' />
    </div>
  )
}

export default ScanButton
